import "./index.css";

const Input = ({
  append = "",
  prepend = "",
  className = "",
  inputClassName = "",
  error = {
    show: false,
    color: "danger",
    content: "",
  },
  ...props
}) => {
  return (
    <div className={`Input flex flex-center ${className}`}>
      {prepend.length > 0 ? (
        <div className="px-1 text-normal">{prepend}</div>
      ) : null}
      <div
        className="input-box mx-2"
        error-show={error.show.toString()}
        error-color={error.color}
        error-content={error.content}
      >
        <input
          className={`text-normal rounded px-2 py-1 ${inputClassName}`}
          lang='en'
          {...props}
        />
      </div>
      {append.length > 0 ? (
        <div className="px-1 text-normal">{append}</div>
      ) : null}
    </div>
  );
};

export default Input;
